"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setRefreshToken = exports.getRefreshToken = exports.applicationDomain = exports.getLoggedUserId = exports.getLoggedLicense = exports.getLoggedEmail = exports.getLoggedRole = exports.getLoggedUserName = exports.isExternalLogin = exports.isLoggedIn = exports.getExternalToken = exports.getOtpToken = exports.setOtpToken = exports.getToken = exports.logout = exports.login = exports.registerDomain = void 0;
/**
 * These methods are used to map the SessionManager singleton methods to functions that can be
 * easily mocked.
 * For example, using:
 * ```
 * import { login } from './path/authentication';
 * login(params);
 * ```
 * is WAY easier to mock than something like
 * import SessionManager from './path/authentication/SessionManager';
 * SessionManager.getInstance().login(params);
 */
var SessionManager_1 = __importDefault(require("./SessionManager"));
function registerDomain(domain) {
    SessionManager_1.default.getInstance().registerDomain(domain);
}
exports.registerDomain = registerDomain;
function login(loginProps) {
    SessionManager_1.default.getInstance().login(loginProps);
}
exports.login = login;
function logout() {
    SessionManager_1.default.getInstance().logout();
}
exports.logout = logout;
function getToken() {
    return SessionManager_1.default.getInstance().getToken();
}
exports.getToken = getToken;
function setOtpToken(token) {
    SessionManager_1.default.getInstance().setOtpToken(token);
}
exports.setOtpToken = setOtpToken;
function getOtpToken() {
    return SessionManager_1.default.getInstance().getOtpToken();
}
exports.getOtpToken = getOtpToken;
function getExternalToken() {
    return SessionManager_1.default.getInstance().getExternalToken();
}
exports.getExternalToken = getExternalToken;
function isLoggedIn() {
    return SessionManager_1.default.getInstance().isLoggedIn();
}
exports.isLoggedIn = isLoggedIn;
function isExternalLogin() {
    return SessionManager_1.default.getInstance().isExternalLoggedIn();
}
exports.isExternalLogin = isExternalLogin;
function getLoggedUserName() {
    return SessionManager_1.default.getInstance().getLoggedUserName();
}
exports.getLoggedUserName = getLoggedUserName;
function getLoggedRole() {
    return SessionManager_1.default.getInstance().getLoggedRole();
}
exports.getLoggedRole = getLoggedRole;
function getLoggedEmail() {
    return SessionManager_1.default.getInstance().getLoggedEmail();
}
exports.getLoggedEmail = getLoggedEmail;
function getLoggedLicense() {
    return SessionManager_1.default.getInstance().getLoggedLicense();
}
exports.getLoggedLicense = getLoggedLicense;
function getLoggedUserId() {
    return SessionManager_1.default.getInstance().getLoggedUserId();
}
exports.getLoggedUserId = getLoggedUserId;
function applicationDomain(domain) {
    return SessionManager_1.default.getInstance().applicationDomain(domain);
}
exports.applicationDomain = applicationDomain;
function getRefreshToken() {
    return SessionManager_1.default.getInstance().getRefreshToken();
}
exports.getRefreshToken = getRefreshToken;
function setRefreshToken(refreshToken) {
    return SessionManager_1.default.getInstance().setRefreshToken(refreshToken);
}
exports.setRefreshToken = setRefreshToken;
//# sourceMappingURL=authenticationMethods.js.map